import React, { useState, useCallback, useEffect, useRef } from 'react';

import classNames from 'classnames';
import Header from './Header';
import Controls from './Controls';
import PublishingOverlay from './PublishingOverlay';
import Subtitles from './Subtitles';

import classes from './styles.module.scss';
import { useUiStore } from '../../store';
import useResizeObserver from '../../hooks/useResizeObserver';

let animationId;

export default function VideoPlayerOverlay({
  meetingTitle,
  setIsShareMeetingModalVisible,
  videoRef,
  videoDuration,
  isDraggingProgressBar,
  progressBarRef,
  mouseDownHandler,
  isVideoReady,
  isAudio,
  stopVideoPlayer,
  pauseVideoPlayer,
  startVideoPlayer,
  startTimer,
  isRecording,
  createSectionMode,
  setAudioImage,
  isPlaying,
  arePlayerButtonsVisible,
  videoSectionPlayerRef,
  isPublishing,
  viewOnly,
  onBackClick,
  fullscreenContainerRef,
  onRewind,
  hasSubtitles,
  trackRef,
  isEditPage,
  noHeader,
  secondaryVideoRef,
  miniPlayer,
}) {
  const [videoProgress, setVideoProgress] = useState(0);
  const [areSubtitlesEnabled, setAreSubtitlesEnabled] = useState(false);

  const containerRef = useRef();
  const { height } = useResizeObserver(containerRef);

  const setVideoPlayerHeight = useUiStore(
    (state) => state.setVideoPlayerHeight
  );

  useEffect(() => {
    setVideoPlayerHeight(height);
  }, [height, setVideoPlayerHeight]);

  const animateProgressBar = useCallback(() => {
    const newLocal =
      (100 / videoSectionPlayerRef.current?.duration) *
      videoSectionPlayerRef.current?.currentTime;
    setVideoProgress(newLocal);

    animationId = requestAnimationFrame(animateProgressBar);
  }, [videoSectionPlayerRef]);

  useEffect(() => {
    if (isPlaying) {
      animateProgressBar();
    }
  }, [isPlaying, animateProgressBar]);

  return (
    <div
      style={{
        pointerEvents: isPublishing ? 'none' : 'auto',
      }}
      className={classNames(classes.VideoPlayerOverlay, {
        [classes.publishing]: isPublishing,
      })}
      onClick={() => {
        if (isPlaying) {
          pauseVideoPlayer();
        } else {
          startVideoPlayer();
          //   animateProgressBar();
        }
      }}
    >
      <div className={classes.container} ref={containerRef}>
        <Header
          noHeader={noHeader}
          isPublishing={isPublishing}
          meetingTitle={meetingTitle}
          setIsShareMeetingModalVisible={setIsShareMeetingModalVisible}
          viewOnly={viewOnly}
          onBackClick={onBackClick}
        />
        <Controls
          videoProgress={videoProgress}
          animateProgressBar={animateProgressBar}
          arePlayerButtonsVisible={arePlayerButtonsVisible}
          videoRef={videoRef}
          videoDuration={videoDuration}
          isDraggingProgressBar={isDraggingProgressBar}
          progressBarRef={progressBarRef}
          mouseDownHandler={mouseDownHandler}
          isVideoReady={isVideoReady}
          isAudio={isAudio}
          stopVideoPlayer={stopVideoPlayer}
          pauseVideoPlayer={pauseVideoPlayer}
          startVideoPlayer={startVideoPlayer}
          startTimer={startTimer}
          isRecording={isRecording}
          createSectionMode={createSectionMode}
          setAudioImage={setAudioImage}
          isPlaying={isPlaying}
          videoSectionPlayerRef={videoSectionPlayerRef}
          animationId={animationId}
          meetingTitle={meetingTitle}
          fullscreenContainerRef={fullscreenContainerRef}
          onRewind={onRewind}
          hasSubtitles={hasSubtitles}
          setAreSubtitlesEnabled={setAreSubtitlesEnabled}
          isEditPage={isEditPage}
          secondaryVideoRef={secondaryVideoRef}
          miniPlayer={miniPlayer}
        />
        {isPublishing && <PublishingOverlay />}
      </div>
      {areSubtitlesEnabled && hasSubtitles && (
        <Subtitles videoRef={videoRef} trackRef={trackRef} />
      )}
    </div>
  );
}
